import { toast } from "react-toastify";
import { getAllRatingGroup } from "../thunk";
import {  fetchdeleteRatingGroupFailure, fetchdeleteRatingGroupSuccess } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { RATING_GROUP_API } from "../../constants/constants";

export const deleteRatingGroup = (id, serviceIdentifier, serviceContextID, setLoading, navigate) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${RATING_GROUP_API}/${id}/${serviceIdentifier}/${serviceContextID}`, 'DELETE').then((response) => {
        if (!response.error) {
            dispatch(fetchdeleteRatingGroupSuccess(response))
            setLoading(false)
            dispatch(getAllRatingGroup(setLoading))
            toast.success(`Rating Group Deleted Successfully`)
        }
        if (response.error) {
            dispatch(fetchdeleteRatingGroupFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}